export enum EnStockChangeMode {
    none = 'NONE',
    separation = 'SEPARACAO',
    checkin = 'CHECKIN',
}
